import{__require as e}from"../start_of_day/index.js";var r,t;function i(){if(t)return r;t=1;var i=e();return r=function(e,r){var t=i(e),n=i(r),f=t.getTime()-6e4*t.getTimezoneOffset(),o=n.getTime()-6e4*n.getTimezoneOffset();return Math.round((f-o)/864e5)}}export{i as __require};
//# sourceMappingURL=index.js.map
